import { DatePicker, Select, Table, TableColumnsType } from 'antd';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import SimpleHeader from '../../components/layout/SimpleHeader';
import SelectCampus from '../../components/SelectCampus';
import Button from '../../components/Button';
import useAxios from '../../hooks/useAxios';
import { IGetSteps } from '../../models/courses.model';
import { IClass2, IGetAllClasses } from '../../models/campusClasses.model';
import { getSteps } from '../../api/courses.api';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/rootReducer';
import { getAllClasses } from '../../api/campusClasses.api';
import DownloadButton from '../../components/DownloadButton';
import {
  IGetPaymentCharges,
  IPaymentCharge,
} from '../../models/payments.model';
import useNotification from '../../hooks/useNotification';
import { getPaymentCharges } from '../../api/payments.api';
import _ from 'lodash';
import Checkbox from '../../components/Checkbox';
import { useHistory } from 'react-router-dom';
import DatePickerTable from '../../components/statistics/DatePickerTable';
import exportTable from '../../lib/exportTable';
import { IGetSemesters, ISemester } from '../../models/semesters.model';
import { getSemesters } from '../../api/semesters.api';
import ScrollTableWrapper from '../../components/ScrollTableWrapper';
import useLoader from '../../hooks/useLoader';
import EduStepSelect from '../../components/common/EduStepSelect';
import useUtil from '../../hooks/useUtil';
import { DateTableType } from '../../constans';
import ScrollView from '../../components/payment/ScrollView';
import TableEmpty from '../../components/common/TableEmpty';

const PaymentCharge: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { infoNotification } = useNotification();
  const { getCommonCodeLabel } = useUtil();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0005 = 연도
  const SY0005 = commonCodes.find(
    (item) => item.commonCode === 'SY0005',
  )?.detailCode;
  const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find(
    (item) => item.commonCode === 'PR0002',
  )?.detailCode;

  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetPaymentCharges>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSteps>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetAllClasses>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetSemesters>();
  useLoader(
    isLoading || isLoading2 || isLoading3 || isLoading4 ,
    [error, error2, error3, error4],
  );

  const [semesterCode, setSemesterCode] = useState<string>();
  const [paymentTargetCode, setPaymentTargetCode] = useState<string>();
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [levelCode, setLevelCode] = useState<string>();
  const [levelList, setLevelList] = useState<any>([]);
  const [classCode, setClassCode] = useState<string>();
  const [classList, setClassList] = useState<IClass2[]>([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selects, setSelects] = useState<string[]>([]);
  const [isSelectAll, setIsSelectAll] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [defSelType, setDefSelType] = useState<number>(2);
  const [year, setYear] = useState('');
  const [semesterType, setSemesterType] = useState("");
  const [semesterData, setSemesterData] = useState<ISemester[]>([]);

  useEffect(() => {
    execute2(getSteps());
    execute4(getSemesters());
  }, []);

  useEffect(() => {
    if (currentCampus) {
      execute3(getAllClasses(currentCampus));
    }
  }, [currentCampus]);

  useEffect(() => {
    if (serverDate) {
      setStartDate(moment(serverDate).format('YYYYMMDD'));
      setEndDate(moment(serverDate).format('YYYYMMDD'));
    }
  }, [serverDate]);

  useEffect(() => {
    if (res) {
      let total = 0;
      res.data.forEach((item: IPaymentCharge) => {
        total += item.targetPrice;
      });
      setTotalAmount(total);
      setData(res.data);
    }
  }, [res]);

  useEffect(() => {
    if (res2) {
      const list: any = [];
      res2.data.forEach((item) => {
        list.push({
          levelCode: item.courseCode,
          levelName: item.courseName,
          eduStepCode: item.eduStepCode,
        });
      });
      setLevelList(list);
    }
  }, [res2]);

  useEffect(() => {
    if (res3) {
      setClassList(res3?.data || []);
    }
  }, [res3]);

  useEffect(() => {
    let _classList = res3?.data || [];

    if (semesterCode) {
      _classList = _classList.filter(item => item.semesterCode === Number(semesterCode));
    }
    if (levelCode) {
      const level = levelList.find((item: any) => item.levelCode === levelCode);
      _classList = _classList.filter(item => item.levelName === level?.levelName) || [];
    }

    setClassList(_classList);
    setClassCode(undefined);
  }, [semesterCode, levelCode]);

  useEffect(() => {
    if (levelCode) {
      const level = levelList.find((item: any) => item.levelCode === levelCode);
      const _classList = res3?.data?.filter(item => item.levelName === level?.levelName) || [];
      setClassList(_classList);
    } else {
      setClassList(res3?.data || []);
    }
    setClassCode(undefined);
  }, [levelCode]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
    setSemesterCode(undefined);
  }, [year]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
    setSemesterCode(undefined);
  }, [semesterType]);

  useEffect(() => {
    fnSetSemesterData(year, semesterType);
  }, [res4]);

  const onSetSelects = (memberCode: string) => {
    if (selects.includes(memberCode)) {
      setSelects(selects.filter((item: any) => item !== memberCode));
      setIsSelectAll(false);
    } else {
      setSelects([...selects, memberCode]);
    }
  };

  const onSelectAll = () => {
    if (isSelectAll) {
      setSelects([]);
      setIsSelectAll(false);
    } else {
      const _selects: string[] = _.uniq(
        data.map((item: any) => item.memberCode),
      );
      setSelects(_selects);
      setIsSelectAll(true);
    }
  };

  const getLevelOptions = () => {
    const levels = eduStepCode
      ? levelList.filter((item: any) => item.eduStepCode === eduStepCode)
      : levelList;
    return levels.map((item: any) => (
      <Select.Option
        key={item.levelCode}
        value={item.levelCode}
      >
        {item.levelName}
      </Select.Option>
    ));
  };

  const onSearch = () => {
    if (!startDate || !endDate) {
      return infoNotification(t('payment.charge.message1'));
    }

    const params: any = {
      campusCode: currentCampus,
      paymentTargetCode,
      semesterCode,
      levelCode,
      classCode,
      srtDate: startDate,
      endDate: endDate,
    };
    if (eduStepCode) {
      params.eduStepCode = eduStepCode;
    }

    execute(getPaymentCharges(params));
    setSelects([]);
    setIsSelectAll(false);
  };

  const onSendSms = () => {
    if (!selects.length) {
      return infoNotification(t('payment.charge.message2'));
    }

    const students: any = [];
    selects.forEach((memberCode: string) => {
      const row = data.find((item: any) => item.memberCode === memberCode);
      if (row) {
        students.push({ ...row, courseName: row.levelName });
      }
    });

    sessionStorage.setItem('students', JSON.stringify(students));
    history.push('/sms/member/send');
  };

  const onExportTable = () => {
    const filename = `${t('payment.charge.1')}_${moment(serverDate).format('YYMMDD')}`;
    const _data = _.cloneDeep(data);
    _data.forEach((item: any) => {
      item.paymentTargetCode = getCommonCodeLabel('PA0001', item.paymentTargetCode);
      item.eduStepCode = getCommonCodeLabel('PR0006', item.eduStepCode);
    });
    exportTable(
      columns.slice(1),
      _data,
      filename,
      filename,
      [20, 10, 15, 20, 20, 15, 15, 10, 10, 15],
    );
  };

  const fnSetSemesterData = (year : string, semesterType : string) => {
    if(res4) {
      let data: ISemester[] = _.cloneDeep(res4.data);

      if(year) {
        data = data.filter((item: any) => item.learningYearCode === year);
      }

      if(semesterType) {
        data = data.filter((item: any) => item.semesterType === semesterType);
      }

      setSemesterData(data);
    }
  }

  const columns: TableColumnsType<IPaymentCharge> = [
    {
      title: (
        <Checkbox
          checked={isSelectAll}
          onClickCapture={(e: any) => {
            e.stopPropagation();
            onSelectAll();
          }}
          text=""
        />
      ),
      dataIndex: 'memberCode',
      align: 'center',
      render: value => {
        let checked = false;
        if (selects.includes(value) || isSelectAll) checked = true;

        return (
          <Checkbox
            checked={checked}
            onChange={() => onSetSelects(value)}
            onClickCapture={(e) => {
              e.stopPropagation();
              onSetSelects(value);
            }}
            text=""
          />
        );
      },
    },
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value),
    },
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      align: 'center',
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
    },
    {
      title: t('payment.charge.column1'),
      dataIndex: 'monthNameCode',
      align: 'center',
      sorter: (a, b) => a.monthNameCode?.localeCompare(b.monthNameCode),
      render: (value: string) =>
        getCommonCodeLabel('SY0009', value?.trim()),
    },
    {
      title: t('payment.charge.column2'),
      dataIndex: 'levelName',
      align: 'center',
      sorter: (a, b) => a.levelName?.localeCompare(b.levelName),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      align: 'center',
      sorter: (a, b) => a.className?.localeCompare(b.className),
    },
    {
      title: t('payment.charge.column3'),
      dataIndex: 'paymentTargetCode',
      align: 'center',
      sorter: (a, b) => a.paymentTargetCode?.localeCompare(b.paymentTargetCode),
      render: value => getCommonCodeLabel('PA0001', value),
    },
    {
      title: t('payment.coupon.placeholder2'),
      dataIndex: 'memberName',
      align: 'center',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
    },
    {
      title: t('payment.charge.column4'),
      dataIndex: 'memberCode',
      align: 'center',
      sorter: (a, b) => a.memberCode?.localeCompare(b.memberCode),
    },
    {
      title: t('student.student.column8'),
      dataIndex: 'siblingName',
      align: 'center',
      render: (value) => {
        let parts = value.split(",");
        return parts.length > 2 ? parts.slice(0, 2).join(",") + '...' : value;
      },
    },
    {
      title: t('payment.charge.column5'),
      dataIndex: 'price',
      align: 'center',
      sorter: (a, b) => a.price - b.price,
      render: value => value?.toLocaleString(),
    },
    {
      title: t('payment.charge.column6'),
      dataIndex: 'targetPrice',
      key: 'targetPrice',
      align: 'center',
      sorter: (a, b) => a.targetPrice - b.targetPrice,
      render: value => value?.toLocaleString(),
    },
    {
      title: t('payment.charge.column7'),
      dataIndex: 'paymentCloseDate',
      key: 'paymentCloseDate',
      align: 'center',
      sorter: (a, b) => a.paymentCloseDate?.localeCompare(b.paymentCloseDate),
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>
              {t('program.semester.column9')}
            </label>
            <Select
              className="w-120p"
              value={year}
              onChange={value => setYear(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                _SY0005!.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>
          <li>
            <label>
              {t('program.semester.column11')}
            </label>
            <Select
              className="w-120p"
              value={semesterType}
              onChange={value => setSemesterType(value)}
            >
              <Select.Option key={'all'} value={''}>
                {t('common.text.all')}
              </Select.Option>
              {
                PR0002?.map(({korName: label, detailCode: value}) => {
                  return (
                    <Select.Option key={value} value={value}>
                      {label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </li>    
          <li>
            <label>{t('common.column.semester')}</label>
            <div>
              <Select
                placeholder={t('statistics.regularTest.placeholder2')}
                value={semesterCode}
                onChange={(value) => setSemesterCode(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {semesterData?.map((item) => (
                  <Select.Option
                    key={item.semesterCode}
                    value={item.semesterCode}
                  >
                    {item.semesterName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.charge.column3')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.column3')}
                value={paymentTargetCode}
                onChange={(value) => setPaymentTargetCode(value)}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                <Select.Option value="PT">{t('payment.charge.option1')}</Select.Option>
                <Select.Option value="TU">{t('payment.charge.option2')}</Select.Option>
                <Select.Option value="ON">{t('payment.charge.option3')}</Select.Option>
                <Select.Option value="AL">{t('payment.charge.option4')}</Select.Option>
                <Select.Option value="ST">{t('payment.charge.option5')}</Select.Option>
                <Select.Option value="SC">{t('payment.charge.option6')}</Select.Option>
              </Select>
            </div>
          </li>
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <EduStepSelect
                eduStepCode={eduStepCode}
                setEduStepCode={value => {
                  setEduStepCode(value);
                  setLevelCode(undefined);
                }}
                includeAll
                fullWidth
              />
            </div>
          </li>
          <li>
            <label>{t('payment.charge.column2')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.column2')}
                value={levelCode}
                onChange={(value) => setLevelCode(value)}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {getLevelOptions()}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('payment.charge.placeholder1')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.placeholder1')}
                value={classCode}
                onChange={(value) => setClassCode(value)}
                disabled={!semesterCode}
              >
                <Select.Option value="">
                  {t('common.text.all')}
                </Select.Option>
                {classList.map((item: any) => {
                  return (
                    <Select.Option
                      key={item.classCode}
                      value={item.classCode}
                    >
                      {item.className}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </li>
          <li className="period">
            <label>{t('sms.list.column1')}</label>
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center">  
                <div className="date-picker__area">
                  <DatePicker
                    value={startDate ? moment(startDate) : undefined}
                    onChange={(e) => {
                      if (e === null) setStartDate('');
                      else setStartDate(moment(e).format('YYYYMMDD'));
                    }}
                  />
                  ~
                  <DatePicker
                    value={endDate ? moment(endDate) : undefined}
                    onChange={(e) => {
                      if (e === null) setEndDate('');
                      else setEndDate(moment(e).format('YYYYMMDD'));
                    }}
                  />
                </div>
                <div className="comm-btn__area">
                  <Button
                    className="btn-basic small black"
                    onClick={onSearch}
                    text={t('common.button.search')}
                  />
                </div>
              </div>
              <div className="comm-btn__area mt-2">
                <DatePickerTable
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  type={DateTableType.ALL}
                  defSelType={defSelType}
                  setDefSelType={setDefSelType}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-payment-big.svg"
        parentMenu={t('common.menu.payment')}
        currentMenu={t('payment.charge.title1')}
        onlyTitle={true}
      />
      <div className="col-frame">
        {data.length > 0 ? (
          <>
            <div className="comm-bx__between">
              <div className="comm-sch_result">
                {t('payment.charge.text1')}: <b>{totalAmount.toLocaleString()}</b>{t('payment.charge.text2')}
              </div>
            </div>
            <div className='comm-table__area'>
              <Table
                columns={columns}
                dataSource={data}
                pagination={{
                  pageSize: 9999999,
                }}
              />
            </div>
            <div className="comm-bx__between">
              <div className="comm-btn__area">
                <DownloadButton
                  onClick={onExportTable}
                />
              </div>
              <div className="comm-btn__area">
                <Button
                  className="btn-basic pink-line"
                  onClick={onSendSms}
                  text={t('payment.charge.button1')}
                />
              </div>
            </div>
          </>
        ) : (
          <TableEmpty text={t('payment.charge.text3')} />
        )}
      </div>
    </div>
    </>
  );
};

export default PaymentCharge;
